<div class="company__logo flex sm:justify-around items-center gap-6 overflow-x-auto sm:mt-10 mt-[4rem]">
  <div inlineSVG="company-logo/google.svg"></div>
  <div inlineSVG="company-logo/slack.svg"></div>
  <div inlineSVG="company-logo/amazon.svg"></div>
  <div inlineSVG="company-logo/zoom.svg"></div>
  <div inlineSVG="company-logo/netflix.svg"></div>
</div>
